const state = {
    orderCache: []
}

const mutations = {
    setCache: (state, cache) => {
        state.orderCache = cache
    },
    initCache(state) {
        state.orderCache = []
    }
}
const actions = {
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
